var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.condition)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.yes)))]):_vm._e(),(!_vm.condition)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.no)))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }